import { render, staticRenderFns } from "./commonApp.vue?vue&type=template&id=223b0444&scoped=true"
import script from "./commonApp.vue?vue&type=script&lang=js"
export * from "./commonApp.vue?vue&type=script&lang=js"
import style0 from "./commonApp.vue?vue&type=style&index=0&id=223b0444&prod&scoped=true&lang=css"
import style1 from "./commonApp.vue?vue&type=style&index=1&id=223b0444&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223b0444",
  null
  
)

export default component.exports